import React from 'react';

const Experience = () => {
    return (
        <div name='experience' className='w-full text-gray-300 bg-[#0a192f] py-16'>
            <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>

                {/* Work Experience Section */}
                <div className='pb-8'>
                    <p className='text-4xl font-bold inline border-b-4 border-blue-600'>Work Experience</p>
                </div>

                <div className='grid gap-8'>
                    {/* MIU */}
                    <div className='bg-[#112240] p-6 rounded-lg shadow-md hover:scale-105 duration-300'>
                        <div className='flex justify-between items-center mb-4 flex-wrap'>
                            <h3 className='text-2xl font-bold text-white'>Software Developer</h3>
                            <span className='text-gray-400'>04/2022 – 02/2025</span>
                        </div>
                        <h4 className='text-xl text-blue-400 mb-2'>MIU</h4>
                        <ul className='list-disc list-inside text-gray-300 space-y-2'>
                            <li>Collaborated with the team to spearhead the development and deployment of a dynamic e-commerce platform using PHP and WordPress, enhancing user experience and boosting sales for clients in Singapore.</li>
                            <li>Led a cross-functional team in the implementation of a scalable Node.js and MongoDB-based backend solution for real-time analytics.</li>
                            <li>Innovated front-end design strategies utilizing HTML, CSS, and Figma, resulting in visually stunning interfaces.</li>
                            <li>Integrated React.js into existing systems, accelerating development cycles.</li>
                            <li>Developed and contributed to Java-based software projects delivering scalable, high-quality applications.</li>
                        </ul>
                    </div>

                    {/* THE GYM */}
                    <div className='bg-[#112240] p-6 rounded-lg shadow-md hover:scale-105 duration-300'>
                        <div className='flex justify-between items-center mb-4 flex-wrap'>
                            <h3 className='text-2xl font-bold text-white'>Software Developer</h3>
                            <span className='text-gray-400'>09/2022 - 04/2023</span>
                        </div>
                        <h4 className='text-xl text-blue-400 mb-2'>The Gym</h4>
                        <ul className='list-disc list-inside text-gray-300 space-y-2'>
                            <li>Participated in real-world software engineering projects, including WordPress websites using PHP.</li>
                            <li>Conducted testing on newly developed software applications, collaborating effectively within a team environment.</li>
                            <li>Demonstrated proficiency in creating HTML templates, JavaScript files, and CSS for UI module development.</li>
                            <li>Improved public speaking skills, confidently presenting work and utilizing technical terminology during demos.</li>
                        </ul>
                    </div>

                    {/* ANDELA */}
                    <div className='bg-[#112240] p-6 rounded-lg shadow-md hover:scale-105 duration-300'>
                        <div className='flex justify-between items-center mb-4 flex-wrap'>
                            <h3 className='text-2xl font-bold text-white'>Trainee Software Developer</h3>
                            <span className='text-gray-400'>01/2022 - 12/2022</span>
                        </div>
                        <h4 className='text-xl text-blue-400 mb-2'>Andela</h4>
                        <ul className='list-disc list-inside text-gray-300 space-y-2'>
                            <li>Attended training to learn software development theory, techniques, and coding best practices.</li>
                            <li>Tested new software applications, ensuring they worked as intended and were user-friendly.</li>
                            <li>Successfully created HTML templates, JavaScript files, and CSS for UI module development.</li>
                            <li>Thoroughly evaluated user feedback and worked closely with team members to identify and remove software bugs.</li>
                        </ul>
                    </div>
                </div>

                {/* Education Section */}
                {/* <div className='pb-8 pt-16'>
                    <p className='text-4xl font-bold inline border-b-4 border-blue-600'>Education</p>
                </div>
                <div className='bg-[#112240] p-6 rounded-lg shadow-md'>
                    <h3 className='text-2xl font-bold text-white'>Secondary School</h3>
                    <p className='text-xl text-blue-400'>PCM, Lycée de Kigali</p>
                    <p className='text-gray-400'>2019 - 2021</p>
                </div> */}

                {/* References Section */}
                <div className='pb-8 pt-16'>
                    <p className='text-4xl font-bold inline border-b-4 border-blue-600'>References</p>
                </div>
                <div className='grid sm:grid-cols-3 gap-4'>
                    <div className='bg-[#112240] p-6 rounded-lg shadow-md'>
                        <h4 className='font-bold text-lg text-white'>Ndagijimana Sebastien</h4>
                        <p className='text-blue-400'>+250788451691</p>
                        <p className='text-gray-300 break-words'>sebastien.miu@gmail.com</p>
                    </div>
                    <div className='bg-[#112240] p-6 rounded-lg shadow-md'>
                        <h4 className='font-bold text-lg text-white'>Kimon Haars</h4>
                        <p className='text-gray-300 break-words'>kimonhaars@gmail.com</p>
                    </div>
                    <div className='bg-[#112240] p-6 rounded-lg shadow-md'>
                        <h4 className='font-bold text-lg text-white'>Niwemugisha Denis</h4>
                        <p className='text-blue-400'>+250782371420</p>
                        <p className='text-gray-300 break-words'>denis.niwemugisha@andela.com</p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Experience;
